__turbopack_context__.v({
  "campus-datacenter": "ProductsCard-module-scss-module__dyKE_q__campus-datacenter",
  "cardContainer": "ProductsCard-module-scss-module__dyKE_q__cardContainer",
  "cardInfo": "ProductsCard-module-scss-module__dyKE_q__cardInfo",
  "cardTitleWrapper": "ProductsCard-module-scss-module__dyKE_q__cardTitleWrapper",
  "ecommerce": "ProductsCard-module-scss-module__dyKE_q__ecommerce",
  "express-study": "ProductsCard-module-scss-module__dyKE_q__express-study",
  "flipCard": "ProductsCard-module-scss-module__dyKE_q__flipCard",
  "flipCardBack": "ProductsCard-module-scss-module__dyKE_q__flipCardBack",
  "flipCardFront": "ProductsCard-module-scss-module__dyKE_q__flipCardFront",
  "flipCardInner": "ProductsCard-module-scss-module__dyKE_q__flipCardInner",
  "home": "ProductsCard-module-scss-module__dyKE_q__home",
  "imageBG": "ProductsCard-module-scss-module__dyKE_q__imageBG",
  "java-course2": "ProductsCard-module-scss-module__dyKE_q__java-course2",
  "landwind": "ProductsCard-module-scss-module__dyKE_q__landwind",
  "learning-react": "ProductsCard-module-scss-module__dyKE_q__learning-react",
  "luna": "ProductsCard-module-scss-module__dyKE_q__luna",
  "microfront-study": "ProductsCard-module-scss-module__dyKE_q__microfront-study",
  "ppCardContainer": "ProductsCard-module-scss-module__dyKE_q__ppCardContainer",
  "ppCardInfo": "ProductsCard-module-scss-module__dyKE_q__ppCardInfo",
  "ppCardText": "ProductsCard-module-scss-module__dyKE_q__ppCardText",
  "ppLink": "ProductsCard-module-scss-module__dyKE_q__ppLink",
  "ppLinksWrapper": "ProductsCard-module-scss-module__dyKE_q__ppLinksWrapper",
  "projects": "ProductsCard-module-scss-module__dyKE_q__projects",
  "rr-html": "ProductsCard-module-scss-module__dyKE_q__rr-html",
  "shopping-react": "ProductsCard-module-scss-module__dyKE_q__shopping-react",
  "skillsWrapper": "ProductsCard-module-scss-module__dyKE_q__skillsWrapper",
  "spring-project": "ProductsCard-module-scss-module__dyKE_q__spring-project",
  "todolist-back": "ProductsCard-module-scss-module__dyKE_q__todolist-back",
});
